import { jsx as _jsx } from "react/jsx-runtime";
import { hydrateRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "./index.css";
import App from "./App";
hydrateRoot(document.getElementById("root"), _jsx(BrowserRouter, { children: _jsx(App, {}) }));
